import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  Divider,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Typography,
  alpha,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InfoIcon from "@mui/icons-material/Info";
import axios from "axios";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import ModalContent from "../../Common/Modal";
import InfoPopUp from "../../Common/InfoPopUp";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import { useTradingColors } from "../Spot/tradingColorConfig";
import "../MyWallet/mywallet.css";
import "../Spot/Spot.css";

const FUTUREMARGINURL = WEBSERVICE + "/fMargin/";

const FiatSpotColumn = ["Fiat", "Amount", "Transfer To"];
const FiatMarginColumn = [
  "Fiat",
  "Margin Bal",
  "Used",
  "Available",
  "Action",
];
const AssetSpotColumn = ["Asset", "Balance", "Action"];

const Infomodal = [
  {
    title: "Isolated",
    description:
      "Isolated Margin is the margin balance allocated to an individual position. Isolated Margin mode allows traders to manage their risk on their individual positions by restricting the amount of margin allocated to each one. The allocated margin balance for each position can be individually adjusted.",
  },
  {
    title: "Cross",
    description:
      "Cross Wallet is a crypto wallet built to hold multiple blockchain cryptocurrencies in one wallet.",
  },
  {
    title: "Fiat Holdings",
    description:
      "You can do margin and funding in your fiat currency from this section.",
  },
  {
    title: "SPOT WALLET",
    description:
      "You can see your fiat balance, transfer to margins, and fund your fiat through SPOT WALLET.",
  },
  {
    title: "MARGIN WALLET",
    description:
      "You can see your margin wallet balance, used balance, and available margin wallet balance. You can transfer your margin wallet balance to your spot wallet through the transfer to SPOT button ",
  },
  {
    title: "Funding",
    description:
      "You can see your funding here by providing From Date and To Date.",
  },
  {
    title: "Crypto Holdings",
    description:
      "You can do margin and funding in your Cryptocurrency from this section.",
  },
  {
    title: "Transfer to SPOT",
    description:
      "You can transfer your margin wallet balance to the spot wallet through this SPOT button.",
  },
  {
    title: "Margin",
    description:
      "You can transfer your fiat balance to your Margin Wallet through this Margin button.",
  },
  {
    title: "Funding",
    description:
      "You can transfer your fiat balance to Funding Wallet through this Funding button. ",
  },
  {
    title: "MARGIN",
    description:
      "You can transfer your Crypto balance to your Margin Wallet through this Margin link.",
  },
  {
    title: "Funding",
    description:
      "You can transfer your Crypto balance to your Funding Wallet through this Funding link.",
  },
  {
    title: "Portfolio",
    description:
      "You can see your balances on a contract basis (Perpetual, Quarterly).",
  },
  {
    title: "SPOT WALLET",
    description:
      "You can see your Crypto balance, transfer to margins, and fund your Crypto through SPOT WALLET.",
  },
  {
    title: "MARGIN",
    description:
      "You can see your margin wallet balance, used balance, and available margin wallet balance. You can transfer your margin wallet balance to your spot wallet through the transfer to SPOT button.",
  },
  {
    title: "VIEW MY FUNDINGS",
    description:
      "You can see your Fundings here by selecting currency and providing From Date and To Date.",
  },
];

const FutureMarginHoldings = () => {
  const { btncolor } = useSelector((state) => state);
  const theme = localStorage.getItem("theme");
  const { upColor, downColor, pairButtonColor } = useTradingColors();
  const themeBtnColor = pairButtonColor || btncolor || "#1976d2";

  const selectedLeverageType =
    localStorage.getItem("selected_leverage_future")?.slice(0, -1) || 2;
  const [selectedMarginType, setSelectedMarginType] = useState(1); // 1 = Isolated, 2 = Cross
  const [selectedMode, setSelectedMode] = useState("Isolated");
  const [holdingsView, setHoldingsView] = useState("FIAT"); // "FIAT" | "CRYPTO" (no "BOTH")

  const [fiatTab, setFiatTab] = useState("SPOT WALLET");
  const [assetTab, setAssetTab] = useState("SPOT WALLET");

  const [fromData, setFromDate] = useState(null);
  const [toData, setToDate] = useState(null);
  const [returnDate, setReturnDate] = useState(null);
  const [assetFromData, setAssetFromDate] = useState(null);
  const [assetToDate, setAssetToDate] = useState(null);

  const [currency, setCurrency] = useState("");
  const [assetCurrency, setAssetCurrency] = useState("");

  const [marginModal, setMarginModal] = useState(false);
  const [fundingModal, setFundingModal] = useState(false);
  const [marginSpotModal, setMarginSpotModal] = useState(false);
  const [customerFundingModal, setCustomerFundingModal] = useState(false);

  const [myBalanceListForFuture, setMyBalanceListForFuture] = useState([]);
  const [myBalanceListForFutureSpot, setMyBalanceListForFutureSpot] = useState([]);
  const [userBalanceList, setUserBalanceList] = useState([]);
  const [futureFiatHoldingStatus, setFutureFiatHoldingStatus] = useState(true);

  const [amount, setAmount] = useState(0);
  const [cryptoCurrency, setCryptoCurrency] = useState("");
  const [sendAmount, setSendAmount] = useState("");
  const [sendAmountFunding, setSendAmountFunding] = useState("");
  const [sendAmountMargin, setSendAmountMargin] = useState("");

  const [marginWalletBalance, setMarginWalletBalance] = useState(0);
  const [usedBalance, setUsedBalance] = useState(0);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [marginWalletId, setMarginWalletId] = useState(null);
  const [fiatCurrencyId, setFiatCurrencyId] = useState(null);
  const [currencyName, setCurrencyName] = useState("");

  const [fundingHomeViewIsoForFuture, setFundingHomeViewIsoForFuture] = useState([]);
  const [fundingHomeViewCrossForFuture, setFundingHomeViewCrossForFuture] = useState([]);
  const [fundingHomeViewFundingForFuture, setFundingHomeViewFundingForFuture] = useState([]);
  const [fdata, setFdata] = useState([]);

  const [marginWalletBalance1, setMarginWalletBalance1] = useState(0);
  const [usedBalance1, setUsedBalance1] = useState(0);
  const [availableBalance1, setAvailableBalance1] = useState(0);
  const [marginwalletId1, setMarginwalletId1] = useState(null);
  const [currencyId1, setCurrencyId1] = useState(null);
  const [cryptoCurrency1, setCryptoCurrency1] = useState("");

  const [infoModal, setInfoModal] = useState(false);
  const [infoIndex, setInfoIndex] = useState(0);

  const fiatLabels = ["SPOT WALLET", "MARGIN", "VIEW MY FUNDINGS"];
  const assetLabels = ["SPOT WALLET", "MARGIN", "VIEW MY FUNDINGS"];

  const handleInfoModal = (index) => {
    setInfoIndex(index);
    setInfoModal(true);
  };
  const handleCloseInfoModal = () => setInfoModal(false);

  const handleCloseMarginModal = () => {
    setMarginModal(false);
    setSendAmount("");
  };
  const handleCloseFundingModal = () => {
    setFundingModal(false);
    setSendAmountFunding("");
  };
  const handleCloseMarginSpotModal = () => {
    setMarginSpotModal(false);
    setSendAmountMargin("");
  };
  const handleCustomerFundingModalClose = () => setCustomerFundingModal(false);

  const validateNumber = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  const formatDate = (value) => dayjs(value).format("DD-MM-YYYY");

  const getSpecificCurrencyPrecision = (curr) => {
    if (curr === "USD") return 2;
    return 4;
  };

  const getSpecificCurrencyPrecisionFund = (curr) => {
    const precisionMap = {
      USD: 2,
      BCH: 8,
    };
    return precisionMap[curr] || 6;
  };

  const checkUserBlockStatus = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");
    if (!uuid || !token) return false;

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/userAccountStatus`,
        JSON.stringify({ uuid }),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${token}`,
          },
        }
      );

      if (response.data?.error?.error_data !== 0) {
        showToast("error", response.data?.error?.error_msg || "Error checking account status");
        return false;
      }

      if (response.data?.status !== 1) {
        showToast("error", "Your user has been blocked by Admin");
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error in checkUserBlockStatus:", error);
      return false;
    }
  };

  // Load wallet balances on mount
  useEffect(() => {
    getMainWalletBalanceForFutureMargin();
    getUserTransaction();
    getAssetsForFutureMargin();
  }, []);

  useEffect(() => {
    faitmarginForFuture();
  }, [selectedMarginType, selectedLeverageType]);

  const handleMarginTypeSelect = (mode, marginType) => {
    setSelectedMode(mode);
    setSelectedMarginType(marginType);
    setCurrency("");
    setMarginWalletBalance1(0);
    setUsedBalance1(0);
    setAvailableBalance1(0);
    setAssetCurrency("");
    setAssetFromDate(null);
    setAssetToDate(null);
  };

  const getMainWalletBalanceForFutureMargin = () => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");
    if (!uuid || !accessToken) return;

    axios
      .get(`${FUTUREMARGINURL}getMainWalletBalance?uuid=${uuid}`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${accessToken}`,
        },
      })
      .then((response) => {
        const userBalance = response.data?.userBalance || [];
        setMyBalanceListForFuture(userBalance);
        const spotBalance = userBalance.filter((item) => item.currencyType === 1);
        setMyBalanceListForFutureSpot(spotBalance);
      })
      .catch((error) => {
        console.error("Error fetching future wallet balance:", error);
      });
  };

  const getUserTransaction = async () => {
    const uuid = localStorage.getItem("uuid");
    const userId = localStorage.getItem("userId") || localStorage.getItem("user_id");
    const token = localStorage.getItem("access_token");
    if (!token) return;

    const userTransObj = { customerId: userId, uuid };
    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${token}`,
          },
        }
      );
      const result = response.data;
      if (result?.userBalanceList) {
        setUserBalanceList(result.userBalanceList);
        const fiatArray = result.userBalanceList
          .filter((item) => item.currencyType === 1)
          .map((item) => item.currencyCode);

        const hasFiat = fiatArray.includes("USD") || fiatArray.length > 0;
        setFutureFiatHoldingStatus(hasFiat);

        if (!hasFiat) {
          setSelectedMarginType(2);
          setSelectedMode("Cross");
          setHoldingsView("CRYPTO");
        }
      }
    } catch (err) {
      console.error("Error fetching user balance:", err);
    }
  };

  const getAssetsForFutureMargin = () => {
    const token = localStorage.getItem("access_token");
    if (!token) return;

    axios
      .get(`${FUTUREMARGINURL}fundingHomeView`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${token}`,
        },
      })
      .then((response) => {
        const currenciesIso = response.data?.P_ISO_MARGIN_CURRENCY || [];
        const currenciesCross = response.data?.P_CROSS_MARGIN_CURRENCY || [];
        const currenciesFunding = response.data?.P_FUNDING_CURRENCY || [];

        const arrIso = currenciesIso.filter((item) => item.CURRENCY_TYPE !== 1);
        const arrCross = currenciesCross.filter((item) => item.CURRENCY_TYPE !== 1);
        const arrFunding = currenciesFunding.filter((item) => item.CURRENCY_TYPE !== 1);

        setFundingHomeViewIsoForFuture(arrIso);
        setFundingHomeViewCrossForFuture(arrCross);
        setFundingHomeViewFundingForFuture(arrFunding);
      })
      .catch((err) => {
        console.error("Error fetching future margin assets:", err);
      });
  };

  const faitmarginForFuture = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");
    if (!uuid || !token) return;

    try {
      const url = `${FUTUREMARGINURL}getMarginWalletByCurrency?uuid=${uuid}&currencyName=USD&marginType=${selectedMarginType}&leverage=${selectedLeverageType}`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${token}`,
        },
      });

      if (response.data?.error !== 1) {
        setMarginWalletBalance(Number(response.data.marginWalletBalance || 0).toFixed(2));
        setUsedBalance(response.data.usedBalance || 0);
        setAvailableBalance(Number(response.data.availableBalance || 0).toFixed(2));
        setMarginWalletId(response.data.marginWalletId);
      } else {
        setMarginWalletBalance(0);
        setUsedBalance(0);
        setAvailableBalance(0);
      }
    } catch (err) {
      console.error("Error fetching fiat margin wallet:", err);
    }
  };

  const somethingChangedForFuture = async (currencyBal) => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");
    if (!uuid || !token || !currencyBal) return;

    try {
      const response = await axios.get(`${FUTUREMARGINURL}getMarginWalletByCurrency`, {
        params: {
          uuid,
          currencyName: currencyBal,
          marginType: selectedMarginType,
          leverage: selectedLeverageType,
        },
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${token}`,
        },
      });
      const data = response.data;
      if (data?.error !== 1) {
        const precision = getSpecificCurrencyPrecision(currencyBal);
        setMarginWalletBalance1(Number(data.marginWalletBalance || 0).toFixed(precision));
        setUsedBalance1(data.usedBalance || 0);
        setAvailableBalance1(Number(data.availableBalance || 0).toFixed(precision));
        setMarginwalletId1(data.marginWalletId);
        setCurrencyId1(data.currencyId);
        setCryptoCurrency1(data.currencyName);
      } else {
        setMarginWalletBalance1(0);
        setUsedBalance1(0);
        setAvailableBalance1(0);
      }
    } catch (err) {
      console.error("Error fetching crypto margin wallet:", err);
    }
  };

  const handleIsoFiatSpotClick = async (modalType, currentBal, cur, curId = "") => {
    const isAllowed = await checkUserBlockStatus();
    if (!isAllowed) return;

    setFiatCurrencyId(curId);
    setAmount(currentBal);
    setCryptoCurrency(cur);
    if (modalType === "margin") {
      setMarginModal(true);
    } else {
      setFundingModal(true);
    }
  };

  const handleIsoFiatMarginSpot = async (crypto, bal, curId, marginWltId) => {
    const isAllowed = await checkUserBlockStatus();
    if (!isAllowed) return;

    setCryptoCurrency(crypto);
    setCurrencyName(crypto);
    setAmount(bal);
    setFiatCurrencyId(curId);
    setMarginWalletId(marginWltId);
    setMarginSpotModal(true);
  };

  const assetlendingPrice = async () => {
    const objdata = {
      uuid: localStorage.getItem("uuid"),
      amount: sendAmount,
      currencyId: fiatCurrencyId,
      baseCurrencyId: fiatCurrencyId,
      unitPrice: "0",
      marginType: selectedMarginType,
      assetPair: cryptoCurrency,
    };

    try {
      const response = await axios.post(
        `${FUTUREMARGINURL}transferBalanceToMWB`,
        JSON.stringify(objdata),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data?.error === 1) {
        showToast("error", response.data?.message || "Margin transfer failed. Please try again.");
      } else {
        showToast("success", "Margin successful");
        getUserTransaction();
        getMainWalletBalanceForFutureMargin();
        faitmarginForFuture();
        if (currencyName) somethingChangedForFuture(currencyName);
        handleCloseMarginModal();
      }
    } catch (err) {
      showToast("error", "Something went wrong.");
    }
  };

  const assetfundBuy = async () => {
    const objdata = {
      uuid: localStorage.getItem("uuid"),
      amount: Number(sendAmountFunding),
      currencyId: fiatCurrencyId,
      baseCurrencyId: fiatCurrencyId,
      unitPrice: 50,
      returnDate: formatDate(returnDate),
      assetPair: cryptoCurrency?.toUpperCase(),
    };

    try {
      const response = await axios.post(
        `${FUTUREMARGINURL}transferFund`,
        JSON.stringify(objdata),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data?.returnId !== 1) {
        showToast("error", response.data?.message || "Funding request failed.");
      } else {
        showToast("success", "Funding successful");
        getUserTransaction();
        getMainWalletBalanceForFutureMargin();
        handleCloseFundingModal();
      }
    } catch (err) {
      showToast("error", "Funding transfer failed.");
    }
  };

  const fiatholdingPrice = async () => {
    const cryptomargintowalletObj = {
      uuid: localStorage.getItem("uuid"),
      marginWalletId,
      amount: Number(sendAmountMargin),
      currencyId: fiatCurrencyId,
      marginType: selectedMarginType,
    };

    try {
      const response = await axios.post(
        `${FUTUREMARGINURL}transferBalanceMarginToMainWallet`,
        JSON.stringify(cryptomargintowalletObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data?.error !== 0) {
        showToast("error", response.data?.message || "Transfer failed.");
      } else {
        showToast("success", response.data?.message || "Transfer to Spot successful.");
        getUserTransaction();
        getMainWalletBalanceForFutureMargin();
        faitmarginForFuture();
        if (currencyName) somethingChangedForFuture(currencyName);
        setFiatTab("SPOT WALLET");
        setAssetTab("SPOT WALLET");
        handleCloseMarginSpotModal();
      }
    } catch (err) {
      showToast("error", "Transfer to Spot failed.");
    }
  };

  const handleIsoFiatFundSubmit = async (type) => {
    const isAllowed = await checkUserBlockStatus();
    if (!isAllowed) return;

    if (type === 1) {
      assetFundingMargin(fromData, toData, 1);
    } else {
      if (!assetCurrency) {
        showToast("error", "Please Fill-up all field");
        return;
      }
      assetFundingMargin(assetFromData, assetToDate, assetCurrency);
    }
  };

  const assetFundingMargin = (fDate, tDate, curId) => {
    if (!fDate || !tDate) {
      showToast("error", "Please Fill-up from date and to date both");
      return;
    }
    if (fDate > tDate) {
      showToast("error", "To Date Must be greater than from date!!");
      return;
    }
    const objdatafund = {
      uuid: localStorage.getItem("uuid"),
      currencyId: curId,
      fromDate: formatDate(fDate),
      toDate: formatDate(tDate),
    };

    axios
      .post(
        `${FUTUREMARGINURL}fundingViewByInputValue`,
        JSON.stringify(objdatafund),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((response) => {
        const list = response.data?.fundingHomeResponseDtoList || [];
        const arr = list.map((item) => {
          const curr = item.currencyName;
          const amt =
            curr === "US Dollar"
              ? parseFloat(item.amount || 0).toFixed(getSpecificCurrencyPrecisionFund("USD"))
              : curr === "BCC"
              ? parseFloat(item.amount || 0).toFixed(getSpecificCurrencyPrecisionFund("BCH"))
              : parseFloat(item.amount || 0).toFixed(getSpecificCurrencyPrecisionFund(curr));

          return {
            currencyName: curr === "US Dollar" ? "USD" : curr === "BCC" ? "BCH" : curr,
            lendingDate: item.lendingDate,
            returnDate: item.returnDate,
            amount: amt,
          };
        });
        setFdata(arr);
        setCustomerFundingModal(true);
        setToDate(null);
        setFromDate(null);
        setAssetToDate(null);
        setAssetFromDate(null);
      })
      .catch((err) => {
        showToast("error", "Failed to fetch funding history.");
      });
  };

  const handleChangeCurrency = (event) => {
    const curId = event.target.value;
    setCurrency(curId);
    setFiatCurrencyId(curId);
    const activeList = selectedMarginType === 1 ? fundingHomeViewIsoForFuture : fundingHomeViewCrossForFuture;
    const filterdata = activeList.filter((d) => d?.CURRENCYID === curId);
    if (filterdata.length > 0) {
      const curName = filterdata[0]?.CURRENCYNAME === "BCC" ? "BCH" : filterdata[0]?.CURRENCY_NAME;
      setCurrencyName(curName);
      somethingChangedForFuture(curName);
    }
  };

  const activeMarginCurrencies =
    selectedMarginType === 1 ? fundingHomeViewIsoForFuture : fundingHomeViewCrossForFuture;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--body-color-less)",
        color: "var(--text-color)",
        overflow: "hidden",
      }}
    >
      {/* ── Top Header matching Buy/Sell bs-tabbar ── */}
      <div
        className="bs-tabbar"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {futureFiatHoldingStatus && (
            <button
              type="button"
              className={`bs-tab ${holdingsView === "FIAT" ? "active-bs-tab" : ""}`}
              style={holdingsView === "FIAT" ? { "--btn-color": themeBtnColor } : {}}
              onClick={() => setHoldingsView("FIAT")}
            >
              FIAT HOLDINGS
            </button>
          )}
          <button
            type="button"
            className={`bs-tab ${holdingsView === "CRYPTO" ? "active-bs-tab" : ""}`}
            style={holdingsView === "CRYPTO" ? { "--btn-color": themeBtnColor } : {}}
            onClick={() => setHoldingsView("CRYPTO")}
          >
            CRYPTO HOLDINGS
          </button>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <ContainedButton
            size="small"
            onClick={() => handleMarginTypeSelect("Isolated", 1)}
            sx={{
              backgroundColor: selectedMode === "Isolated" ? themeBtnColor : "rgba(125,125,125,0.18)",
              color: selectedMode === "Isolated" ? "#fff" : "var(--text-color)",
              opacity: selectedMode === "Isolated" ? 1 : 0.75,
              fontSize: "11px",
              fontWeight: 700,
              px: 1.2,
              py: 0.3,
              minWidth: "auto",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: selectedMode === "Isolated" ? themeBtnColor : "rgba(125,125,125,0.28)",
                opacity: 1,
              },
            }}
          >
            ISOLATED
          </ContainedButton>
          <InfoIcon
            style={{ cursor: "pointer", color: "#a8a1a1", fontSize: "16px" }}
            onClick={() => handleInfoModal(0)}
          />
          <ContainedButton
            size="small"
            onClick={() => handleMarginTypeSelect("Cross", 2)}
            sx={{
              backgroundColor: selectedMode === "Cross" ? themeBtnColor : "rgba(125,125,125,0.18)",
              color: selectedMode === "Cross" ? "#fff" : "var(--text-color)",
              opacity: selectedMode === "Cross" ? 1 : 0.75,
              fontSize: "11px",
              fontWeight: 700,
              px: 1.2,
              py: 0.3,
              minWidth: "auto",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: selectedMode === "Cross" ? themeBtnColor : "rgba(125,125,125,0.28)",
                opacity: 1,
              },
            }}
          >
            CROSS
          </ContainedButton>
          <InfoIcon
            style={{ cursor: "pointer", color: "#a8a1a1", fontSize: "16px" }}
            onClick={() => handleInfoModal(1)}
          />
        </div>
      </div>

      {/* ── Sub-tabs navigation bar (Spot Wallet, Margin, View My Fundings) ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 1.5,
          py: 0.5,
          borderBottom: "1px solid rgba(125,125,125,0.12)",
          backgroundColor: "var(--body-color-less)",
          gap: 0.6,
          flexShrink: 0,
        }}
      >
        {(holdingsView === "FIAT" ? fiatLabels : assetLabels).map((lbl, idx) => {
          const currentTab = holdingsView === "FIAT" ? fiatTab : assetTab;
          const isTabActive = currentTab === lbl;
          return (
            <Button
              key={lbl}
              size="small"
              onClick={() => {
                if (holdingsView === "FIAT") {
                  setFiatTab(lbl);
                  setFromDate(null);
                  setToDate(null);
                  if (lbl === "SPOT WALLET") getMainWalletBalanceForFutureMargin();
                  if (lbl === "MARGIN") faitmarginForFuture();
                } else {
                  setAssetTab(lbl);
                  setCurrency("");
                  setMarginWalletBalance1(0);
                  setUsedBalance1(0);
                  setAvailableBalance1(0);
                  setAssetCurrency("");
                  setAssetFromDate(null);
                  setAssetToDate(null);
                }
              }}
              sx={{
                py: 0.3,
                px: 1.1,
                fontSize: "10.5px",
                fontWeight: isTabActive ? 700 : 500,
                textTransform: "none",
                borderRadius: "4px",
                backgroundColor: isTabActive ? "rgba(125,125,125,0.14)" : "transparent",
                color: isTabActive ? themeBtnColor : "rgba(180, 185, 195, 0.75)",
                borderBottom: isTabActive ? `2px solid ${themeBtnColor}` : "2px solid transparent",
                "&:hover": {
                  color: themeBtnColor,
                  backgroundColor: "rgba(125,125,125,0.1)",
                },
              }}
            >
              {lbl}
              <InfoIcon
                sx={{ fontSize: "10px", ml: 0.4, cursor: "pointer", opacity: 0.6 }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleInfoModal(holdingsView === "FIAT" ? 3 + idx : 13 + idx);
                }}
              />
            </Button>
          );
        })}
      </Box>

      {/* ── Main Content Area (Matches Buy/Sell padding and var(--body-color-less)) ── */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          p: 1.5,
          backgroundColor: "var(--body-color-less)",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: "4px", height: "4px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(125,125,125,0.3)",
            borderRadius: "4px",
          },
        }}
      >
        {/* FIAT HOLDINGS CONTENT */}
        {holdingsView === "FIAT" && futureFiatHoldingStatus && (
          <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            {fiatTab === "SPOT WALLET" && (
              <TableContainer sx={{ overflowX: "auto", width: "100%" }}>
                <Table size="small" sx={{ minWidth: 260 }}>
                  <TableHead sx={{ backgroundColor: "var(--body-color-less2)" }}>
                    <TableRow
                      sx={{
                        "& th": {
                          fontSize: "10px",
                          py: 0.6,
                          px: 1,
                          fontWeight: 700,
                          color: "rgba(180,185,195,0.85)",
                          borderBottom: "1px solid rgba(125,125,125,0.12)",
                          whiteSpace: "nowrap",
                        },
                      }}
                    >
                      {FiatSpotColumn.map((col, i) => (
                        <TableCell key={i} align={i === 2 ? "right" : "left"}>
                          {col}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {myBalanceListForFutureSpot.length > 0 ? (
                      myBalanceListForFutureSpot.map((b, i) => (
                        <TableRow
                          key={i}
                          sx={{
                            "& td": {
                              fontSize: "11px",
                              py: 0.75,
                              px: 1,
                              borderBottom: "1px solid rgba(125,125,125,0.08)",
                              color: "var(--text-color)",
                            },
                          }}
                        >
                          <TableCell sx={{ fontWeight: 600 }}>{b.currency}</TableCell>
                          <TableCell>{b.currentBalance}</TableCell>
                          <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                            <Button
                              size="small"
                              variant="contained"
                              onClick={() => handleIsoFiatSpotClick("margin", b.currentBalance, b.currency, b.currencyId)}
                              sx={{
                                fontSize: "10px",
                                fontWeight: 700,
                                px: 1,
                                py: 0.2,
                                minHeight: 0,
                                backgroundColor: themeBtnColor,
                                textTransform: "none",
                                mr: 0.5,
                                boxShadow: "none",
                              }}
                            >
                              Margin
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => handleIsoFiatSpotClick("funding", b.currentBalance, b.currency, b.currencyId)}
                              sx={{
                                fontSize: "10px",
                                fontWeight: 700,
                                px: 1,
                                py: 0.2,
                                minHeight: 0,
                                borderColor: themeBtnColor,
                                color: themeBtnColor,
                                textTransform: "none",
                              }}
                            >
                              Funding
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ py: 2, color: "rgba(180,185,195,0.6)", fontSize: "11px", borderBottom: "none" }}>
                          No Fiat Balance
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {fiatTab === "MARGIN" && (
              <TableContainer sx={{ overflowX: "auto", width: "100%" }}>
                <Table size="small" sx={{ minWidth: 280 }}>
                  <TableHead sx={{ backgroundColor: "var(--body-color-less2)" }}>
                    <TableRow
                      sx={{
                        "& th": {
                          fontSize: "10px",
                          py: 0.6,
                          px: 0.8,
                          fontWeight: 700,
                          color: "rgba(180,185,195,0.85)",
                          borderBottom: "1px solid rgba(125,125,125,0.12)",
                          whiteSpace: "nowrap",
                        },
                      }}
                    >
                      {FiatMarginColumn.map((col, i) => (
                        <TableCell key={i} align={i === 4 ? "right" : "left"}>
                          {col}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      sx={{
                        "& td": {
                          fontSize: "11px",
                          py: 0.75,
                          px: 0.8,
                          whiteSpace: "nowrap",
                          borderBottom: "1px solid rgba(125,125,125,0.08)",
                          color: "var(--text-color)",
                        },
                      }}
                    >
                      <TableCell sx={{ fontWeight: 600 }}>USD</TableCell>
                      <TableCell>{marginWalletBalance}</TableCell>
                      <TableCell>{usedBalance}</TableCell>
                      <TableCell sx={{ color: upColor, fontWeight: 600 }}>{availableBalance}</TableCell>
                      <TableCell align="right" sx={{ pr: 1 }}>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={() => handleIsoFiatMarginSpot("USD", marginWalletBalance, 1, marginWalletId)}
                          sx={{
                            fontSize: "10px",
                            fontWeight: 700,
                            px: 1.2,
                            py: 0.25,
                            minHeight: 0,
                            backgroundColor: themeBtnColor,
                            textTransform: "none",
                            boxShadow: "none",
                            borderRadius: "4px",
                          }}
                        >
                          Spot
                        </Button>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {fiatTab === "VIEW MY FUNDINGS" && (
              <Box sx={{ p: 0.5, display: "flex", flexDirection: "column", gap: 1 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <DatePicker
                      format="DD-MM-YYYY"
                      value={fromData}
                      onChange={(nv) => setFromDate(nv)}
                      slots={{ openPickerIcon: CalendarMonthIcon }}
                      slotProps={{
                        textField: {
                          size: "small",
                          placeholder: "From Date",
                          fullWidth: true,
                          sx: {
                            "& .MuiInputBase-root": { height: 32, fontSize: "11px", backgroundColor: "var(--body-color-less2)", borderRadius: "4px" },
                            "& .MuiSvgIcon-root": { fontSize: 16 },
                          },
                        },
                      }}
                    />
                    <DatePicker
                      format="DD-MM-YYYY"
                      value={toData}
                      onChange={(nv) => setToDate(nv)}
                      slots={{ openPickerIcon: CalendarMonthIcon }}
                      slotProps={{
                        textField: {
                          size: "small",
                          placeholder: "To Date",
                          fullWidth: true,
                          sx: {
                            "& .MuiInputBase-root": { height: 32, fontSize: "11px", backgroundColor: "var(--body-color-less2)", borderRadius: "4px" },
                            "& .MuiSvgIcon-root": { fontSize: 16 },
                          },
                        },
                      }}
                    />
                  </Box>
                </LocalizationProvider>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleIsoFiatFundSubmit(1)}
                  sx={{
                    backgroundColor: themeBtnColor,
                    fontSize: "11px",
                    py: 0.5,
                    textTransform: "none",
                    fontWeight: 700,
                    borderRadius: "4px",
                    boxShadow: "none",
                  }}
                >
                  View Fundings
                </Button>
              </Box>
            )}
          </Box>
        )}

        {/* CRYPTO HOLDINGS CONTENT */}
        {holdingsView === "CRYPTO" && (
          <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            {assetTab === "SPOT WALLET" && (
              <TableContainer sx={{ overflowX: "auto", width: "100%" }}>
                <Table size="small" sx={{ minWidth: 260 }}>
                  <TableHead sx={{ backgroundColor: "var(--body-color-less2)" }}>
                    <TableRow
                      sx={{
                        "& th": {
                          fontSize: "10px",
                          py: 0.6,
                          px: 1,
                          fontWeight: 700,
                          color: "rgba(180,185,195,0.85)",
                          borderBottom: "1px solid rgba(125,125,125,0.12)",
                          whiteSpace: "nowrap",
                        },
                      }}
                    >
                      {AssetSpotColumn.map((col, i) => (
                        <TableCell key={i} align={i === 2 ? "right" : "left"}>
                          {col}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {myBalanceListForFuture.filter((b) => b.currencyType === 2).length > 0 ? (
                      myBalanceListForFuture
                        .filter((b) => b.currencyType === 2)
                        .map((b, i) => (
                          <TableRow
                            key={i}
                            sx={{
                              "& td": {
                                fontSize: "11px",
                                py: 0.75,
                                px: 1,
                                borderBottom: "1px solid rgba(125,125,125,0.08)",
                                color: "var(--text-color)",
                              },
                            }}
                          >
                            <TableCell sx={{ fontWeight: 600 }}>{b.currency}</TableCell>
                            <TableCell>{b.currentBalance}</TableCell>
                            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                              {b.isFuturesCrossMargin === 1 && (
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => handleIsoFiatSpotClick("margin", b.currentBalance, b.currency, b.currencyId)}
                                  sx={{
                                    fontSize: "10px",
                                    fontWeight: 700,
                                    px: 1,
                                    py: 0.2,
                                    minHeight: 0,
                                    backgroundColor: themeBtnColor,
                                    textTransform: "none",
                                    mr: 0.5,
                                    boxShadow: "none",
                                  }}
                                >
                                  Margin
                                </Button>
                              )}
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => handleIsoFiatSpotClick("funding", b.currentBalance, b.currency, b.currencyId)}
                                sx={{
                                  fontSize: "10px",
                                  fontWeight: 700,
                                  px: 1,
                                  py: 0.2,
                                  minHeight: 0,
                                  borderColor: themeBtnColor,
                                  color: themeBtnColor,
                                  textTransform: "none",
                                }}
                              >
                                Funding
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ py: 2, color: "rgba(180,185,195,0.6)", fontSize: "11px", borderBottom: "none" }}>
                          No Crypto Balance
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {assetTab === "MARGIN" && (
              <Box sx={{ p: 0.5, display: "flex", flexDirection: "column", gap: 1 }}>
                <FormControl size="small" fullWidth>
                  <InputLabel sx={{ fontSize: "11px", color: "var(--text-color)" }}>Select Currency</InputLabel>
                  <Select
                    value={currency}
                    label="Select Currency"
                    onChange={handleChangeCurrency}
                    sx={{
                      fontSize: "11px",
                      height: 32,
                      borderRadius: "4px",
                      backgroundColor: "var(--body-color-less2)",
                    }}
                  >
                    {activeMarginCurrencies?.map((d, i) => (
                      <MenuItem
                        key={i}
                        value={d?.CURRENCYID}
                        sx={{ fontSize: "11px" }}
                      >
                        {d?.CURRENCYNAME !== "BCC" ? d?.CURRENCY_NAME : "BCH"}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {currency && (
                  <Box
                    sx={{
                      fontSize: "11px",
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.8,
                      mt: 0.5,
                      p: 1.2,
                      backgroundColor: "var(--body-color-less2)",
                      borderRadius: "6px",
                      border: "1px solid rgba(125,125,125,0.12)",
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ color: "rgba(180,185,195,0.8)" }}>Margin Wallet Balance:</span>
                      <span style={{ fontWeight: 700, color: upColor }}>{marginWalletBalance1}</span>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ color: "rgba(180,185,195,0.8)" }}>Used Balance:</span>
                      <span style={{ fontWeight: 700 }}>{usedBalance1}</span>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ color: "rgba(180,185,195,0.8)" }}>Available Balance:</span>
                      <span style={{ fontWeight: 700, color: upColor }}>{availableBalance1}</span>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mt: 0.5 }}>
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => handleIsoFiatMarginSpot(cryptoCurrency1, marginWalletBalance1, currencyId1, marginwalletId1)}
                        sx={{
                          fontSize: "10px",
                          backgroundColor: themeBtnColor,
                          textTransform: "none",
                          fontWeight: 700,
                          borderRadius: "4px",
                          boxShadow: "none",
                          py: 0.3,
                          mr: 0.5,
                        }}
                      >
                        Transfer To Spot
                      </Button>
                      <InfoIcon
                        sx={{ fontSize: "11px", cursor: "pointer", opacity: 0.6, verticalAlign: "middle" }}
                        onClick={() => handleInfoModal(7)}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            {assetTab === "VIEW MY FUNDINGS" && (
              <Box sx={{ p: 0.5, display: "flex", flexDirection: "column", gap: 1 }}>
                <FormControl size="small" fullWidth>
                  <InputLabel sx={{ fontSize: "11px", color: "var(--text-color)" }}>Select Asset</InputLabel>
                  <Select
                    value={assetCurrency}
                    label="Select Asset"
                    onChange={(e) => setAssetCurrency(e.target.value)}
                    sx={{
                      fontSize: "11px",
                      height: 32,
                      borderRadius: "4px",
                      backgroundColor: "var(--body-color-less2)",
                    }}
                  >
                    {fundingHomeViewFundingForFuture.map((d, i) => (
                      <MenuItem
                        key={i}
                        value={d?.CURRENCYID}
                        sx={{ fontSize: "11px" }}
                      >
                        {d?.CURRENCYNAME !== "BCC" ? d?.CURRENCY_NAME : "BCH"}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <DatePicker
                      format="DD-MM-YYYY"
                      value={assetFromData}
                      onChange={(nv) => setAssetFromDate(nv)}
                      slots={{ openPickerIcon: CalendarMonthIcon }}
                      slotProps={{
                        textField: {
                          size: "small",
                          placeholder: "From Date",
                          fullWidth: true,
                          sx: {
                            "& .MuiInputBase-root": { height: 32, fontSize: "11px", backgroundColor: "var(--body-color-less2)", borderRadius: "4px" },
                            "& .MuiSvgIcon-root": { fontSize: 16 },
                          },
                        },
                      }}
                    />
                    <DatePicker
                      format="DD-MM-YYYY"
                      value={assetToDate}
                      onChange={(nv) => setAssetToDate(nv)}
                      slots={{ openPickerIcon: CalendarMonthIcon }}
                      slotProps={{
                        textField: {
                          size: "small",
                          placeholder: "To Date",
                          fullWidth: true,
                          sx: {
                            "& .MuiInputBase-root": { height: 32, fontSize: "11px", backgroundColor: "var(--body-color-less2)", borderRadius: "4px" },
                            "& .MuiSvgIcon-root": { fontSize: 16 },
                          },
                        },
                      }}
                    />
                  </Box>
                </LocalizationProvider>

                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleIsoFiatFundSubmit(2)}
                  sx={{
                    backgroundColor: themeBtnColor,
                    fontSize: "11px",
                    py: 0.5,
                    textTransform: "none",
                    fontWeight: 700,
                    borderRadius: "4px",
                    boxShadow: "none",
                  }}
                >
                  View Fundings
                </Button>
              </Box>
            )}
          </Box>
        )}
      </Box>

      {/* ── MODALS ── */}

      {/* 1. Margin Modal */}
      <ModalContent open={marginModal} onClose={handleCloseMarginModal} title="Transfer to Margin">
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
            <span>Available Balance:</span>
            <span style={{ fontWeight: 700 }}>
              {amount} {cryptoCurrency?.toUpperCase()}
            </span>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <span style={{ fontSize: "12px", opacity: 0.8 }}>Send Amount:</span>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid rgba(125,125,125,0.25)",
                backgroundColor: "var(--body-color-less)",
                color: "var(--text-color)",
              }}
              value={sendAmount}
              onChange={(e) => setSendAmount(e.target.value)}
              onKeyDown={validateNumber}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
            <OutlinedButton variant="outlined" onClick={handleCloseMarginModal}>
              Cancel
            </OutlinedButton>
            <ContainedButton
              variant="contained"
              disabled={!sendAmount || Number(sendAmount) <= 0 || Number(sendAmount) > Number(amount)}
              onClick={assetlendingPrice}
            >
              Transfer
            </ContainedButton>
          </Box>
        </Box>
      </ModalContent>

      {/* 2. Transfer to Spot Modal */}
      <ModalContent open={marginSpotModal} onClose={handleCloseMarginSpotModal} title="Transfer to Spot Wallet">
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
            <span>Available Margin:</span>
            <span style={{ fontWeight: 700 }}>
              {amount} {cryptoCurrency?.toUpperCase()}
            </span>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <span style={{ fontSize: "12px", opacity: 0.8 }}>Send Amount:</span>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid rgba(125,125,125,0.25)",
                backgroundColor: "var(--body-color-less)",
                color: "var(--text-color)",
              }}
              value={sendAmountMargin}
              onChange={(e) => setSendAmountMargin(e.target.value)}
              onKeyDown={validateNumber}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
            <OutlinedButton variant="outlined" onClick={handleCloseMarginSpotModal}>
              Cancel
            </OutlinedButton>
            <ContainedButton
              variant="contained"
              disabled={!sendAmountMargin || Number(sendAmountMargin) <= 0 || Number(sendAmountMargin) > Number(amount)}
              onClick={fiatholdingPrice}
            >
              Transfer
            </ContainedButton>
          </Box>
        </Box>
      </ModalContent>

      {/* 3. Funding Modal */}
      <ModalContent open={fundingModal} onClose={handleCloseFundingModal} title="Transfer to Funding">
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
            <span>Available Balance:</span>
            <span style={{ fontWeight: 700 }}>
              {amount} {cryptoCurrency?.toUpperCase()}
            </span>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <span style={{ fontSize: "12px", opacity: 0.8 }}>Send Amount:</span>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid rgba(125,125,125,0.25)",
                backgroundColor: "var(--body-color-less)",
                color: "var(--text-color)",
              }}
              value={sendAmountFunding}
              onChange={(e) => setSendAmountFunding(e.target.value)}
              onKeyDown={validateNumber}
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <span style={{ fontSize: "12px", opacity: 0.8 }}>Return Date:</span>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD-MM-YYYY"
                value={returnDate}
                minDate={dayjs()}
                onChange={(nv) => setReturnDate(nv)}
                slots={{ openPickerIcon: CalendarMonthIcon }}
                slotProps={{
                  textField: {
                    size: "small",
                    placeholder: "Return Date",
                    fullWidth: true,
                    sx: { backgroundColor: "var(--body-color-less)" },
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
            <OutlinedButton variant="outlined" onClick={handleCloseFundingModal}>
              Cancel
            </OutlinedButton>
            <ContainedButton
              variant="contained"
              disabled={!sendAmountFunding || Number(sendAmountFunding) <= 0 || Number(sendAmountFunding) > Number(amount) || !returnDate}
              onClick={assetfundBuy}
            >
              Submit
            </ContainedButton>
          </Box>
        </Box>
      </ModalContent>

      {/* 4. Customer Funding Results Modal */}
      <ModalContent open={customerFundingModal} onClose={handleCustomerFundingModalClose} title="Funding Details">
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
          <TableContainer sx={{ maxHeight: 300 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ "& th": { fontWeight: 700, fontSize: "11px" } }}>
                  <TableCell>Currency</TableCell>
                  <TableCell>Lending Date</TableCell>
                  <TableCell>Return Date</TableCell>
                  <TableCell align="right">Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fdata.length > 0 ? (
                  fdata.map((d, i) => (
                    <TableRow key={i} sx={{ "& td": { fontSize: "11px" } }}>
                      <TableCell>{d.currencyName}</TableCell>
                      <TableCell>{d.lendingDate}</TableCell>
                      <TableCell>{d.returnDate}</TableCell>
                      <TableCell align="right">{d.amount}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ py: 2 }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <OutlinedButton variant="outlined" onClick={handleCustomerFundingModalClose}>
              Close
            </OutlinedButton>
          </Box>
        </Box>
      </ModalContent>

      {/* 5. Info Popup */}
      <InfoPopUp
        open={infoModal}
        onClose={handleCloseInfoModal}
        title={Infomodal[infoIndex]?.title}
        description={Infomodal[infoIndex]?.description}
      />
    </Box>
  );
};

export default FutureMarginHoldings;
